import PropTypes from 'prop-types'
import React from 'react'
import FormFieldLayout from 'layouts/FormFieldLayout'
import { UNIT_TYPE_SELECTION } from 'containers/LeadGen/constants'
import styles from './styles.scss'

const SelectField = ({
  onChange,
  onFocus,
  onKeyPress,
  options,
  value,
  loading,
  errorMessage,
  name,
  label,
  required,
}) => {
  const hasValueClass = value ? 'has-value' : ''
  const hasError = !!errorMessage

  const errorObject = {
    status: hasError,
    message: errorMessage,
  }

  const listOfOptions = options.map(valueName => <option key={valueName} value={valueName}>{valueName}</option>)
  const extraClasses = loading ? styles.isLoading : ''

  const fieldElement = (
    <select
      name={name}
      className={hasValueClass}
      id={name}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onKeyPress={onKeyPress}
      disabled={loading}
      required={required}
    >
      <option disabled value="" />
      { listOfOptions }
    </select>
  )

  return (
    <FormFieldLayout
      fieldName={name}
      labelText={label}
      fieldElement={fieldElement}
      error={errorObject}
      extraClasses={extraClasses}
    />
  )
}

SelectField.defaultProps = {
  value: '',
  loading: false,
  onChange: f => f,
  onFocus: f => f,
  onKeyPress: f => f,
  errorMessage: '',
  required: false,
  options: UNIT_TYPE_SELECTION,
}

SelectField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyPress: PropTypes.func,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.string),
}

export default SelectField



// WEBPACK FOOTER //
// ./components/form/SelectField/index.jsx